<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Martin Vicencio
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<style scoped>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>

<template>
    <vx-card  title="" code-toggler>

      <div class="vx-row" >
        <!-- CARD 9: DISPATCHED ORDERS -->
          <vx-card  style="margin: 20px;" title="">
              <div class="vx-row lg:flex-row">
                   <span style="margin-left: 60px; margin-top: 10px;"> <h5>Imprimir</h5> </span>
                   <!-- <center>impmijfisda</center> -->
                             <vs-button  color="primary" style="margin-left: 10px;" icon-pack="feather"  icon="icon-printer"  title="Imprimir Horario" size="45px" @click="printpage()"></vs-button>
             </div>
          </vx-card>
      </div>

      <div class="vx-row">

        <!-- CARD 4: SESSION -->

        <!-- CARD 5: SUPPORT TRACKER -->

          <vx-card title="Horario de clases:" id="printContent">
              
            <!-- CARD ACTION -->

            <div class="row">
               <div class="invoice__invoice-detail mt-6">

                      <!-- PERIODO TEMPORAL EN LO QUE COLOCO UNA FUNCION Y TAMBIEN EN LA PARTE DE LA FUNCION ESTA MANUAL CAMBIAR  -->
                    <center> <h4><b>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}} </b></h4> </center>
        
                        <h5> 
                          Matrícula: <b>{{matricula}}</b>   <br>
                             Nombre de alumno:    <b>{{alumno_detalle2['ncompleto']}}</b>  <br>  
                        </h5>
                    </div> 
                    
     
               <!-- <span style="text-align: center;"> -->
                <!-- <h1> {{profesor_detalle['nombres']}} {{profesor_detalle['apellidoPaterno']}} {{profesor_detalle['apellidoMaterno']}}</h1> -->

               <!-- <br>
                <h4><b>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}} </b></h4>
              </span> -->

              <div class="col">
                <div class="table-responsive">
                  <table class="table" style="width:90%;  margin-left: 30px;">
                    <thead>
                    <th></th>
                    <!-- <th v-for="dia in dias_horarios">{{dia.dia}}</th> -->
                  <th style="text-align: center;" v-for="dia in dias_horarios" :key="dia.dia">{{dia.dia}}</th>
                    </thead>
                    <tbody>
                    <tr  v-for="hora in horas_horarios" :key="hora.id">
                      
                      <td style="width: 150px; text-align: right"><strong>{{hora.horario}}</strong></td>
                      <!-- lunes      -->
                      <td  style=" text-align: center;">                       
                           <div v-if="get_clave(1,hora.id)=='Libre'">
                                     <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                        <b>  {{get_clave(1,hora.id)}} </b>
                                       </div>
<!-- <div class="p-3 mb-2 bg-primary text-white">.bg-primary</div>
<div class="p-3 mb-2 bg-secondary text-white">.bg-secondary</div>
<div class="p-3 mb-2 bg-success text-white">.bg-success</div>
<div class="p-3 mb-2 bg-danger text-white">.bg-danger</div>
<div class="p-3 mb-2 bg-warning text-dark">.bg-warning</div> -->
<!-- <div class="p-3 mb-2 bg-info text-white">.bg-info</div> -->
<!-- <div class="p-3 mb-2 bg-light text-dark">.bg-light</div>
<div class="p-3 mb-2 bg-dark text-white">.bg-dark</div>
<div class="p-3 mb-2 bg-white text-dark">.bg-white</div> -->

                            </div> 
                           <div v-else >
                            <div class="p-2 mb-2" style="font-size: 12px; text-align: center;"> 
                             
                             <font color="black"><b> {{get_clave(1,hora.id)}}  </b></font>
                            </div>            
                           </div>  
                     </td>


           <!-- mart      -->
                    <td style=" text-align: center;">                       
                           <div v-if="get_clave(2,hora.id)=='Libre'">
                                       <!-- <vs-button  style="font-size: 12px; width: 100px; height: 30px; padding: 2px;text-align: center;" color="success">  -->
                                        <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                        <b> {{get_clave(2,hora.id)}} </b>
                                       </div>
                            </div> 
                           <div v-else >
                            <!-- <vs-button style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="primary">  -->
                              <div class="p-2 mb-2 " style="font-size: 12px; text-align: center;">
                             
                             <font color="black"><b> {{get_clave(2,hora.id)}}  </b></font>
                             </div>            
                          </div>  
                     </td>
  <!-- mier      -->
                      <td style="text-align: center;">                       
                           <div v-if="get_clave(3,hora.id)=='Libre'">
                                       <!-- <vs-button  style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                        <b> {{get_clave(3,hora.id)}} </b>
                                       </vs-button> -->

                                       <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                        <b> {{get_clave(3,hora.id)}} </b>
                                       </div>
                            </div> 
                           <div v-else >
                            <!-- <vs-button style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="primary"> 
                              
                              <font color="black"><b> {{get_clave(3,hora.id)}}  </b></font>
                             </vs-button>-->
                           <div class="p-2 mb-2" style="font-size: 12px; text-align: center;"> 
                             <font color="black"><b> {{get_clave(3,hora.id)}}  </b></font>
                             </div>  

                         </div>  
                     </td>
  <!-- juev      -->
                      <td style=" text-align: center;">                       
                           <div v-if="get_clave(4,hora.id)=='Libre'">

                                       <!-- <vs-button  style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                       <b>  {{get_clave(4,hora.id)}} </b>
                                       </vs-button> -->
                                        <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                        <b> {{get_clave(4,hora.id)}} </b>
                                       </div>

                            </div> 
                           <div v-else >
                            <!-- <vs-button  style="font-size: 12px; width: 180px; height: 30px;  padding: 2px;text-align: center;" color="primary">                               
                              <font color="black"><b> {{get_clave(4,hora.id)}}  </b></font>
                             </vs-button>   -->
                              <div class="p-2 mb-2 " style="font-size: 12px; text-align: center;"> 
                             <font color="black"><b> {{get_clave(4,hora.id)}}  </b></font>
                             </div>  
           
                         </div>  
                     </td>

  <!-- vier      -->

                          <td style=" text-align: center;">                       
                           <div v-if="get_clave(5,hora.id)=='Libre'">
                                       <!-- <vs-button  style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                               <b>{{get_clave(5,hora.id)}} </b>
                                       </vs-button> -->
                                          <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                        <b> {{get_clave(5,hora.id)}} </b>
                                       </div>

                            </div> 
                           <div v-else >
                            <!-- <vs-button  style="font-size: 12px; width: 180px; height: 30px;  padding: 2px;text-align: center;" color="primary">                              
                              <font color="black"><b> {{get_clave(5,hora.id)}}  </b></font>
                             </vs-button>   -->
                             <div class="p-2 mb-2" style="font-size: 12px; text-align: center;"> 
                             <font color="black"><b> {{get_clave(5,hora.id)}}  </b></font>
                             </div>

                         </div>  
                     </td>
  <!-- sab      -->

                      <td style=" text-align: center;">                       
                           <div v-if="get_clave(6,hora.id)=='Libre'">
                                       <!-- <vs-button  style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                      <b>  {{get_clave(6,hora.id)}}  </b>                                     
                                       </vs-button> -->
                                 <div class=" p-2 mb-2 bg-success" style="font-size: 12px; text-align: center;" color="success"> 
                                            <b> {{get_clave(6,hora.id)}} </b>
                                 </div>
                            </div> 
                           <div v-else >
                            <!-- <vs-button  style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="primary">                              
                               <font color="black"><b> {{get_clave(6,hora.id)}}  </b></font>
                             </vs-button> -->
                              <div class="p-2 mb-2" style="font-size: 12px; text-align: center;"> 
                             <font color="black"><b> {{get_clave(6,hora.id)}}  </b></font>
                             </div>
                         </div>  
                     </td>
                  
                    </tr>

                    </tbody>
                  </table>
                </div>



              </div>
            </div>


          </vx-card>


      </div>



    </vx-card>
</template>

<script>
// import vSelect from 'vue-select';
import Button from "@/views/components/vuesax/button/Button";
import Table from "@/views/ui-elements/table/Table";
    export default {
        data() {
          return {
            // carrera: localStorage.getItem('id_carrera'),
            //  carrera: localStorage.getItem('id'),
             matricula: localStorage.getItem('matricula'),
            id: localStorage.getItem('id'),
            cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
            horario: [],
            profesor_detalle: [],
            horas_horarios:[{hora:''}],
            dias_horarios:[{dia:''}],
            tabla_horarios:[],
            alumno_detalle2: []

          }
        },
        created(){
          //  this.$vs.loading();
          this.getAlumno();
           this.getCuatrimestreActual();
               this.getProfesor();
         
    
        },
        mounted(){

        },
        watch: {
        
          // cuatrimestre_select: function () {
          //   //this.carrera = this.carreras_select.id
          //   this.$vs.loading();
          //   this.gethorario_cuatrimestre();
          // }

        },
      components:{
        Button,
        Table,
        // 'v-select': vSelect
      },
        methods: {


            getAlumno() {
              this.$http.get("alumno_id/" + this.id).then(
                response => {
                    this.alumno_detalle2 = response.data.alumno;
                },
                error => { this.StepError(error); }
                );
            },
            getProfesor() {
            this.$http.get("catalogos/get_profesor/"+this.id).then(
                response => {
                    // console.log(response.data)
                    this.profesor_detalle = response.data.profesor;
                 //   console.log(this);

                },
                error => {
                    this.StepError(error);
                }
            );
        },

         printpage(){
                    
              let newstr = document.getElementById("printContent").innerHTML;
              let oldstr = document.body.innerHTML;
              document.body.innerHTML = newstr;
              // scale(0.85);
              window.print();
              // window.printPreview();
              document.body.innerHTML = oldstr;
              location.reload()
              return false;
              // location.reload()
              // window.print();
        
        },
        
     get_clave(dia, hora){
                
            return this.tabla_horarios[hora + "" + dia];

          },

          getCuatrimestreActual(){
            this.$http.get("cuatrimestre_siguiente").then(
                response => {
                  this.cuatrimestre_actual = response.data.cuatrimestre_siguiente;
                  var idAgno=this.cuatrimestre_actual[0].idAgno;
                  var idPeriodo=this.cuatrimestre_actual[0].idPeriodo;
                 this.gethorario_cuatrimestre(idAgno,idPeriodo);
                 this.getHoras();
                 this.getDias();
                },
                error => {
                  this.StepError(error);
                }
            );
          },

          // getCuatrimestreSiguiente(){
          //   this.$http.get("cuatrimestre_siguiente").then(
          //       response => {
          //         this.cuatrimestre_siguiente = response.data.cuatrimestre_siguiente;
          //         this.getReferencias();   
          //         this.cuatrimestre_actual_alumno();
          //          this.traer_carga();
          //         },
          //       error => {
          //         this.StepError(error);
          //       }
          //   );

          // },

          gethorario_cuatrimestre(idAgno,idPeriodo){
            this.$http.get("horario_cuatrimestre_alumno/"+this.id+"/"+idAgno+"/"+idPeriodo).then(
                response => {
                  this.tabla_horarios = response.data.horario_cuatrimestre_alumno_v1;
                  console.log(idPeriodo);

                },
                error => {
                  this.StepError(error);
                }
            );

          },
      
       getHoras(){
            this.$http.get("horas_horarios").then(
                response => {
                  this.horas_horarios = response.data.horas_horarios;
                },
                error => {
                  this.StepError(error);
                }
            );
          },
          getDias(){
            this.$http.get("dias_horarios").then(
                response => {
                  this.dias_horarios = response.data.dias_horarios;
                },
                error => {
                  this.StepError(error);
                }
            );
          },


        }
    }
</script>



